var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepairCarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 19.2C12.6599 19.2 13.1999 19.74 13.1999 20.4H5.9999C5.9999 19.74 6.5399 19.2 7.1999 19.2H8.9999V13.2H5.9999V13.8C5.9999 14.16 5.7599 14.4 5.3999 14.4H4.1999C3.8399 14.4 3.5999 14.16 3.5999 13.8V12V8.39998H2.3999C2.3999 7.73998 2.9399 7.19998 3.5999 7.19998H3.9599L4.7399 4.85998C4.9799 4.07998 5.6399 3.59998 6.4199 3.59998H12.7799C13.5599 3.59998 14.2199 4.07998 14.4599 4.85998L15.2399 7.19998H15.5999C16.2599 7.19998 16.7999 7.73998 16.7999 8.39998H15.5999V12V13.2V13.8C15.5999 14.16 15.3599 14.4 14.9999 14.4H13.7999C13.4399 14.4 13.1999 14.16 13.1999 13.8V13.2H10.1999V19.2H11.9999ZM4.7999 12H14.3999V8.39998L13.3199 5.21998C13.2599 4.97998 13.0199 4.79998 12.7799 4.79998H6.4199C6.1799 4.79998 5.9399 4.97998 5.8799 5.21998L4.7999 8.39998V12ZM12.3599 5.99998L13.1399 8.39998H6.0599L6.8399 5.99998H12.3599ZM13.1999 9.59998H11.9999V10.8H13.1999V9.59998ZM5.9999 9.59998H7.1999V10.8H5.9999V9.59998ZM20.3999 8.51998C21.1199 8.75998 21.5999 9.41998 21.5999 10.2C21.5999 10.98 21.1199 11.64 20.3999 11.88V17.4C20.3999 17.76 20.1599 18 19.7999 18C19.4399 18 19.1999 17.76 19.1999 17.4V11.88C18.4799 11.64 17.9999 10.98 17.9999 10.2C17.9999 9.41998 18.4799 8.75998 19.1999 8.51998V10.2C19.1999 10.56 19.4399 10.8 19.7999 10.8C20.1599 10.8 20.3999 10.56 20.3999 10.2V8.51998Z",
    fill: "#0562D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairCarBlue);
export default __webpack_public_path__ + "static/media/repair-car-blue.21778e9dc9dd47e96545b1ff9d2882b3.svg";
export { ForwardRef as ReactComponent };